import { Inventory2Outlined, AddOutlined, EditOutlined, ToggleOnOutlined, DeleteOutline } from "@mui/icons-material";
import * as React from 'react';
import { DataGrid, GridColDef, GridRowId } from '@mui/x-data-grid';
import autenticaStore from '../../stores/autentica.store';
import IBodyRequest from '../../types/IBodyRequest';
import http from '../../http';
import { useState } from "react";
import Botao from '../../components/Botao';
import Container from "../../components/Container";
import Titulo from "../../components/Titulo";
import ModalProduto from './Modal';
import IProduto, { formatDuracaoAcesso } from '../../types/IProduto';
import { mostrarMensagem } from "../../stores/mensagem.store";





export default function Produto(){
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'origem', headerName: 'Origem', width: 200},
    { field: 'nome', headerName: 'Nome', width: 400 },
    { field: 'descricao', headerName: 'Descrição', width: 600 },
    { field: 'duracaoAcesso', headerName: 'Duração do acesso', width: 180, valueGetter: (params) => formatDuracaoAcesso(params.row.duracaoAcessoQuantidade, params.row.duracaoAcessoUnidade) },
    { field: 'active', headerName: 'Ativo', width: 130 },
  ];
  
  
  
    const [produtos, setprodutos] = useState<IProduto[]>([]);
    const [selectedRows, setSelectedRows] = useState<GridRowId[]>([]);
    const [atulizarTabela, setAtulizarTabela] = useState(false);
    const [open, setOpen ] = useState(false);
    const [editaOpen, setEditaOpen ] = useState(false);
    const [tipo, setTipo] = useState("");
    const {usuario} = autenticaStore;
  
    
    const axiosConfig = {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${usuario.token}`,
      },
    };
    
    React.useEffect(() => {
        http.get<IBodyRequest<IProduto>>('produtos?size=500', axiosConfig)
        .then(resposta => {
            setprodutos(resposta.data.content)
            //console.log("Ta atualizando Produto")
            //console.log(resposta.data.content)
        })
        .catch(erro => {
            mostrarMensagem(erro, "error")
        })
  
    }, [atulizarTabela, open, editaOpen]);
  
    const handleOpen = (tipo: string) => {
      if(tipo === "cadastra"){
        setTipo("cadastra")
        setOpen(true)
      }else if(tipo === "edita"){       
        if(selectedRows.length == 0){
          mostrarMensagem("nenhum registro selecionado!", "warning")
        }else if(selectedRows.length > 1){
          mostrarMensagem("Favor selecionar um unico registro!", "warning")
        }else{
          setTipo("edita")
          setOpen(true)
        }
      }
    }

    const handleClose =() => {
      setOpen(false)    
    }

    const ativaDesativa = () => {
      
      if(selectedRows.length == 0){
        mostrarMensagem("nenhum registro selecionado!", "warning")
      }else if(selectedRows.length > 1){
        mostrarMensagem("Favor selecionar um unico registro!", "warning")
      }else{
        let id = selectedRows[0]
        const produto = produtos.find(item => item.id === id);
  
        if(produto?.active){
          http.put(`produtos/desativar/${id}`, null, axiosConfig)
          .then(resposta => {
              mostrarMensagem("produto desativado!", "success")
              //console.log(resposta)
              setAtulizarTabela(!atulizarTabela)
          })
          .catch(erro => {
            mostrarMensagem(erro, "error")
          })
        }else{
          http.put(`produtos/ativar/${id}`,null ,axiosConfig)
          .then(resposta => {
              mostrarMensagem("produto ativado!", "success")
              //console.log(resposta)
              setAtulizarTabela(!atulizarTabela)
          })
          .catch(erro => {
            //console.log("deu ruim")
            mostrarMensagem(erro, "error")
          })
        }
      }
    }
    const excluir = () => {
      
      if(selectedRows.length == 0){
        mostrarMensagem("nenhum registro selecionado!", "warning")
      }else if(selectedRows.length > 1){
        mostrarMensagem("Favor selecionar um unico registro!", "warning")
      }else{
        let id = selectedRows[0]
  
        http.delete(`produtos/${id}`, axiosConfig)
        .then(resposta => {
            mostrarMensagem("produto excluido!", "success")
            //console.log(resposta)
            setAtulizarTabela(!atulizarTabela)
        })
        .catch(erro => {
          mostrarMensagem(erro, "error")
        })   
      }
    }


  return (
    
    <Container >
          <Titulo icone={<Inventory2Outlined />}>Produtos</Titulo>
          <div style={{ height: '100%', width: '100%'}}>
            <Botao onClick={() =>  handleOpen("cadastra")}><AddOutlined aria-hidden="true" />Cadastrar</Botao>
            <Botao onClick={() =>  handleOpen("edita")}><EditOutlined aria-hidden="true" />Editar/Precificar</Botao>
            <Botao onClick={() =>  ativaDesativa()}><ToggleOnOutlined aria-hidden="true" />Ativar/Desativar</Botao>
            <Botao onClick={() =>  excluir()} style={{backgroundColor: "#c50000", borderColor: "#c50000"}}><DeleteOutline aria-hidden="true" />Excluir</Botao>
            <ModalProduto open={open} handleClose={handleClose} produtos={produtos} id={selectedRows} tipo={tipo}/>

            <DataGrid style={{ backgroundColor: "#fffdfa",
                              borderBottomColor: "rgba(85, 8, 29, 0.12)",
                              borderTopColor: "rgba(85, 8, 29, 0.12)",
                              color: "#35252b",
                              borderColor:"rgba(85, 8, 29, 0.12)",

                            }}
              rows={produtos}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 20 },
                },
              }}
              pageSizeOptions={[20, 30, 40]}
              checkboxSelection
              disableRowSelectionOnClick
              onRowSelectionModelChange={(ids) => {setSelectedRows(ids)}}
            />
          </div>
    </Container>
  );
}
